import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          L&T Realty Island Cove Mahim - Overview
        </h1>

        <p>
          Welcome to Island Cove by L&T Realty — Mahim's most anticipated gated
          development that redefines urban living with exclusivity, elegance,
          and ease. Situated in the culturally rich and centrally located suburb
          of Mahim, this premium project offers 3 & 4 Bed residences with
          world-class amenities and design sensibilities.
          <br />
          Boasting over 20,000 sq. ft. of lifestyle amenities, Mahim's
          first-ever high-street community seamlessly integrates luxury living
          with high-end retail, wellness, workspaces, and entertainment zones —
          all within a secure, serene enclave curated for the elite few.
          <br />
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          L&T Realty Island Cove Mahim - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Mahim's first gated residential development</span>
              </li>
              <li>
                <span>20,000 sq. ft. lifestyle experience zone</span>
              </li>
              <li>
                <span>25+ lifestyle and wellness amenities</span>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>
                  Mahim's first retail avenue within a gated community
                </span>
              </li>
              <li>
                <span>Smartly planned homes with premium interiors</span>
              </li>
              <li>
                <span>
                  Pet Day Care, Library, Co-Working & Creche facilities
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
